import React from 'react';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';

import PreviewModalProps from './PreviewCampaign.props';
import getTemplateBody from './PreviewCampaign.utils';

const PreviewModal = ({
  isOpen,
  subject,
  body,
  footer,
  onClose,
}: PreviewModalProps): JSX.Element => {
  const emailBody = getTemplateBody(subject, body, footer);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Email Preview</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <div dangerouslySetInnerHTML={{ __html: emailBody }} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
export default PreviewModal;
